const ProsAndCons = ({ data, name }) => {
  const cons = data.filter((e) => !e?.isPro);
  const pros = data.filter((e) => e?.isPro);
  return (
    <section className="mt-12 max-w-[1440px] mx-auto px-5 sm:px-8 md:px-12 lg:px-16 xl:px-20 transition-colors duration-300">
      {/* Header */}
      <div className="mb-6 text-left">
        <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
          {name} Pros & Cons
        </h2>
        <hr className="border-t-1 border-gray-400 dark:border-gray-600 mb-4 w-full" />
        <p className="text-gray-600 dark:text-gray-300">
          A quick overview of what we think are the top good and bad things
          about {name}.
        </p>
      </div>

      {/* Pros & Cons Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* ✅ Pros */}
        <div
          className="border border-gray-300 dark:border-gray-600 rounded-xl 
                     bg-white dark:bg-[#1e2430] transition-colors duration-300 
                     pt-8 pb-6 px-8" // reduced bottom padding
        >
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4 text-left">
            Pros
          </h3>
          <ul className="space-y-3 text-left pl-0">
            {pros.map((pro, index) => (
              <li key={index} className="flex items-center gap-3 pl-0">
                <span
                  className="flex items-center justify-center w-7 h-7 rounded-full 
                             bg-green-100 dark:bg-[#2a2f3d] border border-green-500 
                             text-green-500 text-base"
                >
                  ✔
                </span>
                <span className="text-gray-800 dark:text-gray-200">
                  {pro.description}
                </span>
              </li>
            ))}
          </ul>
        </div>

        {/* ❌ Cons */}
        <div
          className="border border-gray-300 dark:border-gray-600 rounded-xl 
                     bg-white dark:bg-[#1e2430] transition-colors duration-300 
                     pt-8 pb-6 px-8" // reduced bottom padding
        >
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4 text-left">
            Cons
          </h3>
          <ul className="space-y-3 text-left pl-0">
            {cons.map((con, index) => (
              <li key={index} className="flex items-center gap-3 pl-0">
                <span
                  className="flex items-center justify-center w-7 h-7 rounded-full 
                             bg-red-100 dark:bg-[#2a2f3d] border border-red-500 
                             text-red-500 text-base"
                >
                  ✖
                </span>
                <span className="text-gray-800 dark:text-gray-200">
                  {con.description}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default ProsAndCons;
